import { ChangeDetectorRef, Component, forwardRef, Inject, OnInit } from '@angular/core';
import { FormActivityEditorComponent } from '../../form-activity-editor/form-activity-editor.component';
import { SecurityService, WorkflowContextService, WorkflowService } from 'src/app/services';
import { UntypedFormBuilder } from '@angular/forms';
import { DragulaService } from 'ng2-dragula';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'wm-continuous-activity-editor',
  templateUrl: './continuous-activity-editor.component.html',
  styleUrl: './continuous-activity-editor.component.css',
  standalone: false
})
export class ContinuousActivityEditorComponent extends FormActivityEditorComponent
  implements OnInit {
  constructor(
    @Inject(forwardRef(() => WorkflowService)) workflowSvc: WorkflowService,
    @Inject(forwardRef(() => WorkflowContextService))
    context: WorkflowContextService,
    fb: UntypedFormBuilder,
    dragulaSvc: DragulaService,
    ref: ChangeDetectorRef,
    toastr: ToastrService
  ) {
    super(workflowSvc, context, toastr, fb, dragulaSvc, ref);
  }

  ngOnInit() {}
}
